<script setup lang="ts">

import { faFilterCircleXmark } from '@fortawesome/pro-regular-svg-icons'

import { FilterDateRange } from '@shared/ui/filters'
import { BtnIcon, BtnPrimary } from '@shared/ui/buttons'
import { AppInput } from '@shared/ui/inputs'
import { AppMultiSelect } from '@shared/ui/selects'

import { useFiltersSubscriptions } from '../model/filters-subscriptions.hook'

defineOptions({
  name: 'FiltersSubscriptions',
})

withDefaults(defineProps<{
  /** The customer's Subscriptions tab keeps the legacy filter bar: a Search button and "Search" in the date field. */
  isCustomerTab?: boolean
}>(), {
  isCustomerTab: false,
})

const {
  refSearch,
  refDateRange,
  refStatuses,
  statusOptions,
  isLoading,
  clearFilters,
  submitSearch,
} = useFiltersSubscriptions()
</script>

<template>
  <div class="filters-subscriptions">
    <div class="filters-subscriptions__fields">
      <AppInput
        v-model="refSearch"
        class="filters-subscriptions__search"
        label="Search"
        placeholder="Search"
        :disabled="isLoading"
      />

      <AppMultiSelect
        v-model="refStatuses"
        class="filters-subscriptions__status"
        :options="statusOptions"
        label="Subscription status"
        placeholder="All"
        :disabled="isLoading"
        clearable
      />

      <FilterDateRange
        v-model="refDateRange"
        class="filters-subscriptions__date"
        label="Invoice date"
        :placeholder="isCustomerTab ? 'Search' : 'Select range'"
        :disabled="isLoading"
      />
    </div>

    <div class="filters-subscriptions__controls">
      <BtnIcon
        :icon="faFilterCircleXmark"
        color="red"
        tooltip-text="Clear filters"
        :disabled="isLoading"
        @click="clearFilters"
      />
      <BtnPrimary
        v-if="isCustomerTab"
        text="Search"
        :disabled="isLoading"
        @click="submitSearch"
      />
    </div>
  </div>
</template>

<style scoped lang="scss" src="./FiltersSubscriptions.scss" />
